import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './services/vuetify.service'
import i18n from './i18n'
import './vee-validate'
import './bootstrap/froala.bootstrap'
import './bootstrap/plugins.bootstrap'
import './bootstrap/components.bootstrap'
import './bootstrap/filters.bootstrap'

import './scss/main.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
